import { useEffect, useState } from "react";
import podioRanking from "../assets/podio-ranking.png";

const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : process.env.REACT_APP_API_URL || "https://app.nvplaydigital.com";

function montarUrlLogo(logoEmpresa) {
  if (!logoEmpresa) return "";

  const logo = String(logoEmpresa).trim();

  if (!logo) return "";

  let urlFinal = "";

  if (logo.startsWith("http://") || logo.startsWith("https://")) {
    urlFinal = logo;
  } else if (logo.startsWith("/")) {
    urlFinal = `${API_URL}${logo}`;
  } else {
    urlFinal = `${API_URL}/${logo}`;
  }

  const separador = urlFinal.includes("?") ? "&" : "?";
  return `${urlFinal}${separador}v=${Date.now()}`;
}

function dataHojeBR() {
  return new Date().toLocaleDateString("sv-SE", {
    timeZone: "America/Sao_Paulo",
  });
}

const largura = window.innerWidth;
const mobile = largura < 768;
const notebook = largura >= 768 && largura < 1400;

export default function Ranking() {
  const [ranking, setRanking] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [tipoRanking, setTipoRanking] = useState("geral");
  const [me, setMe] = useState(null);
  const [rankingMeta, setRankingMeta] = useState(null);
  const [mesSelecionado, setMesSelecionado] = useState(() => {
    const hoje = new Date();
    return `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, "0")}`;
  });
  const [periodoPremiacao, setPeriodoPremiacao] = useState("hoje");
  const [inicioPremiacao, setInicioPremiacao] = useState(dataHojeBR());
  const [fimPremiacao, setFimPremiacao] = useState(dataHojeBR());
  const [dataRankingDiario, setDataRankingDiario] = useState(dataHojeBR());
  const [erroRanking, setErroRanking] = useState("");

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  useEffect(() => {
    carregarMe();
  }, []);

  useEffect(() => {
    if (me) carregar();
  }, [tipoRanking, me, mesSelecionado, periodoPremiacao, inicioPremiacao, fimPremiacao, dataRankingDiario]);

  async function carregarMe() {
    try {
      if (!token) {
        setErroRanking("Sessão expirada. Faça login novamente.");
        setTipoRanking("geral");
        setCarregando(false);
        return;
      }

      const res = await fetch(`${API_URL}/me`, {
        headers: { Authorization: token },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.error || "Erro ao carregar usuário.");
      }

      setMe(data);

      if (data?.role === "master" || data?.role === "gestor") {
        setTipoRanking("rede");
      } else {
        setTipoRanking("colaboradores");
      }
    } catch (err) {
      console.log(err);
      setErroRanking(err?.message || "Erro ao carregar usuário.");
      setTipoRanking("geral");
      setCarregando(false);
    }
  }

  async function carregar() {
    setCarregando(true);
    setErroRanking("");
    setRanking([]);
    setRankingMeta(null);

    try {
      let rota = "";

      const parametros = new URLSearchParams();
      parametros.set("includeMeta", "1");

      if (tipoRanking === "diario") {
        parametros.set("data", dataRankingDiario || dataHojeBR());
      } else if (tipoRanking === "vendasNovas") {
        parametros.set("periodo", periodoPremiacao);

        if (periodoPremiacao === "mensal" && mesSelecionado) {
          parametros.set("mes", mesSelecionado);
        }

        if (periodoPremiacao === "manual") {
          if (inicioPremiacao) parametros.set("inicio", inicioPremiacao);
          if (fimPremiacao) parametros.set("fim", fimPremiacao);
        }
      } else if (mesSelecionado) {
        parametros.set("mes", mesSelecionado);
      }

      if (tipoRanking === "rede") rota = `${API_URL}/ranking?${parametros.toString()}`;
      if (tipoRanking === "geral") rota = `${API_URL}/ranking-geral?${parametros.toString()}`;
      if (tipoRanking === "colaboradores") rota = `${API_URL}/ranking-colaboradores?${parametros.toString()}`;
      if (tipoRanking === "vendasNovas") rota = `${API_URL}/ranking-vendas-novas?${parametros.toString()}`;
      if (tipoRanking === "diario") rota = `${API_URL}/ranking-diario?${parametros.toString()}`;

      if (!rota) {
        setRanking([]);
        setRankingMeta(null);
        return;
      }

      const res = await fetch(rota, {
        headers: {
          Authorization: token,
          Accept: "application/json",
          "Cache-Control": "no-cache",
        },
      });

      const textoResposta = await res.text();
      let data = null;

      try {
        data = textoResposta ? JSON.parse(textoResposta) : null;
      } catch (parseErr) {
        console.log("Resposta não JSON recebida no ranking:", {
          rota,
          status: res.status,
          resposta: textoResposta?.slice?.(0, 300),
        });

        throw new Error(
          res.status === 404
            ? "Rota do ranking não encontrada no backend. Atualize o server.js e reinicie o Node/PM2."
            : "A API retornou uma resposta inválida. Atualize o backend e tente novamente."
        );
      }

      if (!res.ok) {
        throw new Error(data?.error || "Erro ao carregar ranking.");
      }

      if (Array.isArray(data)) {
        setRanking(data);
        setRankingMeta({
          totalGeral: data.reduce((acc, item) => acc + Number(tipoRanking === "vendasNovas" ? item.vendasNovas || 0 : item.total || 0), 0),
          totalVendas: data.reduce((acc, item) => acc + Number(item.vendas || item.totalVendas || 0), 0),
          totalVendasNovas: data.reduce((acc, item) => acc + Number(item.vendasNovas || 0), 0),
          data: tipoRanking === "diario" ? dataRankingDiario : undefined,
          periodo: {
            mes: mesSelecionado,
            tipo:
              tipoRanking === "vendasNovas"
                ? periodoPremiacao
                : tipoRanking === "diario"
                ? "diario"
                : "mensal",
            inicio: tipoRanking === "diario" ? dataRankingDiario : undefined,
            fim: tipoRanking === "diario" ? dataRankingDiario : undefined,
          },
        });
      } else {
        setRanking(Array.isArray(data?.ranking) ? data.ranking : []);
        setRankingMeta(data || null);
      }
    } catch (err) {
      console.log(err);
      setErroRanking(err?.message || "Erro ao carregar ranking.");
      setRanking([]);
      setRankingMeta(null);
    } finally {
      setCarregando(false);
    }
  }

  function podeVerRede() {
    return me?.role === "master" || me?.role === "gestor";
  }

  function podeVerColaboradores() {
    return me?.role === "franquia" || me?.role === "colaborador";
  }

  function podeVerPremiacao() {
    return me?.role === "master" || me?.role === "gestor";
  }

  function podeVerDiario() {
    return me?.role !== "colaborador";
  }

  function formatar(valor) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function nome(item) {
    return item?.nomeEmpresa || item?.usuario || "Empresa";
  }

  function subtituloRanking() {
    if (tipoRanking === "rede") return "Ranking da sua rede";
    if (tipoRanking === "colaboradores") return "Ranking de colaboradores";
    if (tipoRanking === "diario") return "Ranking de faturamento do dia";
    if (tipoRanking === "vendasNovas") return "Premiação por vendas novas da sua rede";
    return "Ranking geral";
  }

  function formatarMes(mesAno) {
    if (!mesAno || !/^\d{4}-\d{2}$/.test(mesAno)) return "Mês atual";

    const [ano, mes] = mesAno.split("-");
    const data = new Date(Number(ano), Number(mes) - 1, 1);

    return data.toLocaleDateString("pt-BR", {
      month: "long",
      year: "numeric",
    });
  }

  function formatarDataBR(dataISO) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dataISO || ""))) return "";

    const [ano, mes, dia] = String(dataISO).split("-");
    return `${dia}/${mes}/${ano}`;
  }

  function tituloTotalGeral() {
    if (tipoRanking === "diario") return "Faturamento geral do dia";
    if (tipoRanking === "vendasNovas") return "Total de vendas novas";
    if (tipoRanking === "geral") return "Faturamento geral da rede";
    if (tipoRanking === "rede") return "Faturamento da minha rede";
    return "Faturamento dos colaboradores";
  }

  function valorPrincipal(item) {
    if (tipoRanking === "vendasNovas") {
      const vendas = Math.round(Number(item?.vendasNovas || 0));
      return `${vendas} venda${vendas === 1 ? "" : "s"}`;
    }

    return formatar(item?.total || 0);
  }

  function valorTotalCard() {
    if (tipoRanking === "vendasNovas") {
      const vendas = Math.round(Number(rankingMeta?.totalVendasNovas || 0));
      return `${vendas} venda${vendas === 1 ? "" : "s"}`;
    }

    return formatar(rankingMeta?.totalGeral || 0);
  }

  function descricaoPeriodoPremiacao() {
    const periodo = rankingMeta?.periodo || {};

    if (tipoRanking === "diario") {
      return `Data: ${formatarDataBR(rankingMeta?.data || periodo.inicio || dataRankingDiario)}`;
    }

    if (tipoRanking !== "vendasNovas") {
      return formatarMes(rankingMeta?.periodo?.mes || mesSelecionado);
    }

    if (periodo.tipo === "hoje") return `Hoje • ${periodo.inicio || dataHojeBR()}`;
    if (periodo.tipo === "semana") return `Semana • ${periodo.inicio || ""} até ${periodo.fim || ""}`;
    if (periodo.tipo === "manual") return `Manual • ${periodo.inicio || inicioPremiacao} até ${periodo.fim || fimPremiacao}`;

    return `Mês • ${formatarMes(periodo.mes || mesSelecionado)}`;
  }

  function mensagemRankingVazio() {
    if (tipoRanking === "vendasNovas") return "Nenhuma venda nova encontrada.";
    if (tipoRanking === "diario") {
      return "Nenhum faturamento encontrado para esta data.";
    }

    return "Nenhum faturamento encontrado.";
  }

  function Logo({ item, size = 90 }) {
    const [erroLogo, setErroLogo] = useState(false);

    if (item?.logoEmpresa && !erroLogo) {
      return (
        <img
          src={montarUrlLogo(item.logoEmpresa)}
          alt={nome(item)}
          onError={() => setErroLogo(true)}
          style={{
            width: size,
            height: size,
            borderRadius: "50%",
            objectFit: "cover",
            border: "3px solid rgba(255,255,255,0.92)",
            background: "#fff",
            boxShadow: "0 0 22px rgba(255,255,255,0.35)",
            display: "block",
          }}
        />
      );
    }

    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #020617, #334155)",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "900",
          fontSize: size / 2.5,
          border: "3px solid rgba(255,255,255,0.92)",
          boxShadow: "0 0 22px rgba(255,255,255,0.25)",
        }}
      >
        {nome(item).charAt(0).toUpperCase()}
      </div>
    );
  }

  const primeiro = ranking[0];
  const segundo = ranking[1];
  const terceiro = ranking[2];
  const restante = ranking.slice(3);
  const maiorTotal = Math.max(
    1,
    ...ranking.map((item) =>
      Number(tipoRanking === "vendasNovas" ? item?.vendasNovas || 0 : item?.total || 0)
    )
  );

  return (
    <>
      <style>{`
        @keyframes pulseGlow {
          0% {
            transform: scale(1);
            filter: brightness(1);
          }

          50% {
            transform: scale(1.05);
            filter: brightness(1.25);
          }

          100% {
            transform: scale(1);
            filter: brightness(1);
          }
        }

        @keyframes podioFloat {
          0% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-4px);
          }

          100% {
            transform: translateY(0px);
          }
        }

        @keyframes shineMove {
          0% {
            filter: brightness(1);
          }

          50% {
            filter: brightness(1.35);
          }

          100% {
            filter: brightness(1);
          }
        }
      `}</style>

    <div style={container}>
      <div style={overlay}></div>

      <div style={painel}>
        <div style={header}>
          <h1 style={titulo}>
            {tipoRanking === "diario"
              ? "🔥 Ranking Diário"
              : tipoRanking === "vendasNovas"
              ? "🏅 Ranking de Vendas Novas"
              : "🏆 Ranking Mensal"}
          </h1>

          <div style={botoes}>
            {podeVerRede() && (
              <button
                onClick={() => setTipoRanking("rede")}
                style={{
                  ...botao,
                  background:
                    tipoRanking === "rede"
                      ? "linear-gradient(135deg,#2563eb,#3b82f6)"
                      : "rgba(255,255,255,0.08)",
                  boxShadow:
                    tipoRanking === "rede"
                      ? "0 0 22px rgba(59,130,246,0.45)"
                      : "0 10px 30px rgba(0,0,0,0.22)",
                }}
              >
                🌐 Minha rede
              </button>
            )}

            {podeVerColaboradores() && (
              <button
                onClick={() => setTipoRanking("colaboradores")}
                style={{
                  ...botao,
                  background:
                    tipoRanking === "colaboradores"
                      ? "linear-gradient(135deg,#7c3aed,#9333ea)"
                      : "rgba(255,255,255,0.08)",
                  boxShadow:
                    tipoRanking === "colaboradores"
                      ? "0 0 22px rgba(147,51,234,0.45)"
                      : "0 10px 30px rgba(0,0,0,0.22)",
                }}
              >
                👥 Colaboradores
              </button>
            )}

            {me?.role !== "colaborador" && (
              <button
                onClick={() => setTipoRanking("geral")}
                style={{
                  ...botao,
                  background:
                    tipoRanking === "geral"
                      ? "linear-gradient(135deg,#facc15,#eab308)"
                      : "rgba(255,255,255,0.08)",
                  color: tipoRanking === "geral" ? "#111827" : "#fff",
                  boxShadow:
                    tipoRanking === "geral"
                      ? "0 0 26px rgba(250,204,21,0.45)"
                      : "0 10px 30px rgba(0,0,0,0.22)",
                }}
              >
                🏆 Ranking geral
              </button>
            )}

            {podeVerDiario() && (
              <button
                onClick={() => setTipoRanking("diario")}
                style={{
                  ...botao,
                  background:
                    tipoRanking === "diario"
                      ? "linear-gradient(135deg,#ea580c,#f97316)"
                      : "rgba(255,255,255,0.08)",
                  color: "#fff",
                  boxShadow:
                    tipoRanking === "diario"
                      ? "0 0 26px rgba(249,115,22,0.45)"
                      : "0 10px 30px rgba(0,0,0,0.22)",
                }}
              >
                🔥 Diário
              </button>
            )}

            {podeVerPremiacao() && (
              <button
                onClick={() => setTipoRanking("vendasNovas")}
                style={{
                  ...botao,
                  background:
                    tipoRanking === "vendasNovas"
                      ? "linear-gradient(135deg,#16a34a,#22c55e)"
                      : "rgba(255,255,255,0.08)",
                  color: "#fff",
                  boxShadow:
                    tipoRanking === "vendasNovas"
                      ? "0 0 26px rgba(34,197,94,0.45)"
                      : "0 10px 30px rgba(0,0,0,0.22)",
                }}
              >
                🏅 Vendas novas
              </button>
            )}
          </div>

          <p style={subtitulo}>{subtituloRanking()}</p>

          <div style={controlesRanking}>
            {tipoRanking === "diario" ? (
              <label style={labelMes}>
                Data do ranking
                <input
                  type="date"
                  value={dataRankingDiario}
                  onChange={(e) => setDataRankingDiario(e.target.value)}
                  style={inputMes}
                />
              </label>
            ) : tipoRanking === "vendasNovas" ? (
              <div style={filtrosPremiacao}>
                <div style={botoesPeriodo}>
                  {[
                    ["hoje", "Hoje"],
                    ["semana", "Semana"],
                    ["mensal", "Mês"],
                    ["manual", "Manual"],
                  ].map(([valor, label]) => (
                    <button
                      key={valor}
                      onClick={() => setPeriodoPremiacao(valor)}
                      style={{
                        ...botaoPeriodo,
                        background:
                          periodoPremiacao === valor
                            ? "linear-gradient(135deg,#16a34a,#22c55e)"
                            : "rgba(15,23,42,0.72)",
                        borderColor:
                          periodoPremiacao === valor
                            ? "rgba(134,239,172,0.55)"
                            : "rgba(255,255,255,0.14)",
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>

                {periodoPremiacao === "mensal" && (
                  <label style={labelMes}>
                    Mês da premiação
                    <input
                      type="month"
                      value={mesSelecionado}
                      onChange={(e) => setMesSelecionado(e.target.value)}
                      style={inputMes}
                    />
                  </label>
                )}

                {periodoPremiacao === "manual" && (
                  <div style={camposManual}>
                    <label style={labelMes}>
                      Início
                      <input
                        type="date"
                        value={inicioPremiacao}
                        onChange={(e) => setInicioPremiacao(e.target.value)}
                        style={inputMes}
                      />
                    </label>

                    <label style={labelMes}>
                      Fim
                      <input
                        type="date"
                        value={fimPremiacao}
                        onChange={(e) => setFimPremiacao(e.target.value)}
                        style={inputMes}
                      />
                    </label>
                  </div>
                )}
              </div>
            ) : (
              <label style={labelMes}>
                Histórico mensal
                <input
                  type="month"
                  value={mesSelecionado}
                  onChange={(e) => setMesSelecionado(e.target.value)}
                  style={inputMes}
                />
              </label>
            )}

            <div style={cardTotalRede}>
              <div style={cardTotalTitulo}>{tituloTotalGeral()}</div>
              <div style={cardTotalValor}>{valorTotalCard()}</div>
              <div style={cardTotalSub}>
                {descricaoPeriodoPremiacao()}
                {!['vendasNovas', 'diario'].includes(tipoRanking) && Number(rankingMeta?.totalVendas || 0) > 0
                  ? ` • ${Number(rankingMeta?.totalVendas || 0)} vendas`
                  : ""}
              </div>
            </div>
          </div>

          {erroRanking && <div style={erroBox}>{erroRanking}</div>}
        </div>

        {carregando && <div style={vazio}>Carregando ranking...</div>}

        {!carregando && ranking.length === 0 && (
          <div style={vazio}>{mensagemRankingVazio()}</div>
        )}

        {!carregando && ranking.length > 0 && (
          <div style={layout}>
            <div style={ladoPodio}>
              <div style={podioArea}>
                <img src={podioRanking} alt="Pódio Ranking" style={podioImagem} />

                <TopOverlay
                  item={primeiro}
                  posicao="1º"
                  cor="#facc15"
                  logoSize={mobile ? 44 : notebook ? 52 : 70}
                  style={posPrimeiro}
                  nomeStyle={nomePrimeiro}
                  valorStyle={valorPrimeiro}
                />

                <TopOverlay
                  item={segundo}
                  posicao="2º"
                  cor="#22d3ee"
                  logoSize={mobile ? 34 : notebook ? 40 : 54}
                  style={posSegundo}
                  nomeStyle={nomeSegundo}
                  valorStyle={valorSegundo}
                />

                <TopOverlay
                  item={terceiro}
                  posicao="3º"
                  cor="#fb4b3f"
                  logoSize={mobile ? 34 : notebook ? 40 : 54}
                  style={posTerceiro}
                  nomeStyle={nomeTerceiro}
                  valorStyle={valorTerceiro}
                />

                {!mobile && (
                  <>
                    <ResumoPodio
                      style={resumo1}
                      icon="🏆"
                      titulo="Líder em faturamento"
                      texto="Desempenho excepcional"
                      cor="#22d3ee"
                    />

                    <ResumoPodio
                      style={resumo2}
                      icon="⭐"
                      titulo={tipoRanking === "diario" ? "Destaques do dia" : "Destaques do mês"}
                      texto="Os melhores resultados"
                      cor="#facc15"
                    />

                    <ResumoPodio
                      style={resumo3}
                      icon="🔥"
                      titulo="Competição acirrada"
                      texto="Todos rumo ao topo!"
                      cor="#fb4b3f"
                    />
                  </>
                )}
              </div>
            </div>

            {tipoRanking !== "diario" && restante.length > 0 && (
              <div style={ladoLista}>
                {restante.map((item, index) => (
                  <div key={index} style={linha}>
                    <div style={linhaPosicao}>{index + 4}</div>

                    <Logo item={item} size={mobile ? 42 : notebook ? 46 : 52} />

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={linhaNome}>{nome(item)}</div>

                      <div style={barraFundo}>
                        <div
                          style={{
                            ...barraInterna,
                            width: `${Math.min(
                              maiorTotal > 0
                                ? (Number(tipoRanking === "vendasNovas" ? item.vendasNovas || 0 : item.total || 0) / maiorTotal) * 100
                                : 0,
                              100
                            )}%`,
                          }}
                        />
                      </div>
                    </div>

                    <div style={linhaValor}>{valorPrincipal(item)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
    </>
  );

  function TopOverlay({ item, posicao, cor, logoSize, style, nomeStyle, valorStyle }) {
    if (!item) return null;

    return (
      <div style={{ ...topOverlay, ...style }}>
        <div
          style={{
            ...logoTopWrap,
            borderColor: cor,
            boxShadow: `0 0 18px ${cor}88`,
          }}
        >
          <Logo item={item} size={logoSize} />
        </div>

        <div style={posicaoTop}>{posicao}</div>
        <div style={{ ...nomeTop, ...nomeStyle }}>{nome(item)}</div>
        <div style={{ ...valorTop, ...valorStyle }}>{valorPrincipal(item)}</div>
      </div>
    );
  }

  function ResumoPodio({ style, icon, titulo, texto, cor }) {
    return (
      <div style={{ ...resumoCard, ...style }}>
        <span style={{ ...resumoIcon, filter: `drop-shadow(0 0 10px ${cor})` }}>
          {icon}
        </span>

        <div style={{ minWidth: 0 }}>
          <div style={{ ...resumoTitulo, color: cor }}>{titulo}</div>
          <div style={resumoTexto}>{texto}</div>
        </div>
      </div>
    );
  }
}

const container = {
  minHeight: "100vh",
  padding: mobile ? 14 : notebook ? 20 : 28,
  background:
    "radial-gradient(circle at top, #111827 0%, #080b1f 45%, #020617 100%)",
  color: "white",
  position: "relative",
  overflowX: "hidden",
};

const overlay = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(180deg, rgba(255,255,255,0.035), transparent)",
  pointerEvents: "none",
};

const painel = {
  position: "relative",
  zIndex: 2,
  width: "100%",
  maxWidth: 1580,
  margin: "0 auto",
  borderRadius: mobile ? 0 : 24,
  border: mobile ? "none" : "1px solid rgba(255,255,255,0.07)",
  background: mobile ? "transparent" : "rgba(2,6,23,0.18)",
  boxShadow: mobile ? "none" : "0 26px 80px rgba(0,0,0,0.3)",
  padding: mobile ? 0 : notebook ? 16 : 20,
  boxSizing: "border-box",
};

const header = {
  position: "relative",
  zIndex: 3,
  marginBottom: mobile ? 12 : 16,
};

const titulo = {
  textAlign: "center",
  fontSize: mobile ? 32 : notebook ? 38 : 44,
  lineHeight: 1.1,
  fontWeight: "900",
  margin: mobile ? "8px 0 14px" : "0 0 18px",
  textShadow: "0 8px 28px rgba(0,0,0,0.45)",
};

const botoes = {
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: mobile ? 8 : 12,
};

const botao = {
  border: "1px solid rgba(255,255,255,0.12)",
  padding: mobile ? "10px 13px" : "11px 20px",
  borderRadius: 8,
  fontWeight: "800",
  color: "white",
  cursor: "pointer",
  fontSize: mobile ? 13 : 16,
  backdropFilter: "blur(10px)",
};

const subtitulo = {
  textAlign: "center",
  marginTop: mobile ? 12 : 18,
  color: "#cbd5e1",
  fontSize: mobile ? 15 : 18,
};

const controlesRanking = {
  margin: mobile ? "14px auto 0" : "18px auto 0",
  display: "grid",
  gridTemplateColumns: mobile ? "1fr" : "minmax(190px, 240px) minmax(260px, 420px)",
  gap: mobile ? 10 : 14,
  justifyContent: "center",
  alignItems: "stretch",
  maxWidth: mobile ? "100%" : 860,
};

const labelMes = {
  display: "flex",
  flexDirection: "column",
  gap: 7,
  color: "#cbd5e1",
  fontSize: mobile ? 12 : 13,
  fontWeight: "800",
  letterSpacing: 0.2,
};

const filtrosPremiacao = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
  minWidth: 0,
};

const botoesPeriodo = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
};

const botaoPeriodo = {
  border: "1px solid rgba(255,255,255,0.14)",
  padding: mobile ? "9px 10px" : "10px 13px",
  borderRadius: 12,
  color: "white",
  fontWeight: "900",
  cursor: "pointer",
  fontSize: mobile ? 12 : 13,
};

const camposManual = {
  display: "grid",
  gridTemplateColumns: mobile ? "1fr" : "1fr 1fr",
  gap: 10,
};

const inputMes = {
  width: "100%",
  height: mobile ? 42 : 46,
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.15)",
  background: "rgba(15,23,42,0.72)",
  color: "white",
  padding: "0 12px",
  fontSize: mobile ? 14 : 15,
  fontWeight: "800",
  outline: "none",
  boxSizing: "border-box",
};

const cardTotalRede = {
  borderRadius: 16,
  border: "1px solid rgba(250,204,21,0.24)",
  background:
    "linear-gradient(135deg, rgba(250,204,21,0.15), rgba(59,130,246,0.10), rgba(15,23,42,0.74))",
  boxShadow: "0 18px 45px rgba(0,0,0,0.24)",
  padding: mobile ? "13px 14px" : "14px 18px",
  textAlign: mobile ? "left" : "center",
};

const cardTotalTitulo = {
  color: "#fde68a",
  fontWeight: "900",
  fontSize: mobile ? 12 : 13,
  textTransform: "uppercase",
  letterSpacing: 0.7,
};

const cardTotalValor = {
  marginTop: 4,
  color: "#ffffff",
  fontWeight: "950",
  fontSize: mobile ? 24 : 30,
  lineHeight: 1.05,
  textShadow: "0 7px 24px rgba(0,0,0,0.42)",
};

const cardTotalSub = {
  marginTop: 6,
  color: "#cbd5e1",
  fontSize: mobile ? 12 : 13,
  fontWeight: "700",
};

const erroBox = {
  maxWidth: 720,
  margin: "14px auto 0",
  padding: mobile ? "11px 12px" : "12px 14px",
  borderRadius: 12,
  border: "1px solid rgba(248,113,113,0.32)",
  background: "rgba(127,29,29,0.25)",
  color: "#fecaca",
  fontWeight: "800",
  textAlign: "center",
};

const layout = {
  display: "grid",
  gridTemplateColumns: mobile ? "1fr" : notebook ? "1fr" : "1.02fr 0.98fr",
  gap: mobile ? 16 : notebook ? 22 : 34,
  alignItems: "start",
};

const ladoPodio = { minWidth: 0 };

const ladoLista = {
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: mobile ? 10 : notebook ? 12 : 14,
};

const podioArea = {
  position: "relative",
  animation: "podioFloat 6s ease-in-out infinite",
  width: "100%",
  maxWidth: mobile ? "100%" : notebook ? 900 : 900,
  margin: "0 auto",
  borderRadius: mobile ? 18 : 24,
  overflow: "hidden",
  boxShadow: "0 24px 70px rgba(0,0,0,0.32)",
  background: "rgba(2,6,23,0.7)",
};

const podioImagem = {
  width: "100%",
  display: "block",
  borderRadius: mobile ? 18 : 24,
  userSelect: "none",
  pointerEvents: "none",
};

const topOverlay = {
  position: "absolute",
  transform: "translate(-50%, -50%)",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 5,
  pointerEvents: "none",
};

const logoTopWrap = {
  border: "2px solid",
  animation: "pulseGlow 3s ease-in-out infinite",
  borderRadius: "50%",
  padding: mobile ? 2 : 3,
  background: "rgba(2,6,23,0.9)",
  marginBottom: mobile ? 3 : 6,
};

const posicaoTop = {
  color: "#fff",
  fontWeight: "900",
  lineHeight: 1,
  fontSize: mobile ? 18 : notebook ? 24 : 32,
  textShadow: "0 0 18px rgba(255,255,255,0.35)",
  marginBottom: mobile ? 2 : 4,
};

const nomeTop = {
  fontWeight: "900",
  lineHeight: 1.1,
  textShadow: "0 5px 20px rgba(0,0,0,0.78)",
  overflow: "hidden",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
};

const valorTop = {
  fontWeight: "900",
  color: "#fff",
  textShadow: "0 5px 20px rgba(0,0,0,0.85)",
  whiteSpace: "nowrap",
};

const posPrimeiro = {
  left: "50%",
  top: "47.2%",
  width: "28%",
};

const posSegundo = {
  left: "20.8%",
  top: "54%",
  width: "22%",
};

const posTerceiro = {
  left: "78.0%",
  top: "52.5%",
  width: "22%",
};
const nomePrimeiro = {
  color: "#facc15",
  fontSize: mobile ? 12 : notebook ? 16 : 20,
  WebkitLineClamp: 2,
};

const valorPrimeiro = {
  fontSize: mobile ? 10 : notebook ? 13 : 17,
};

const nomeSegundo = {
  color: "#22d3ee",
  fontSize: mobile ? 10 : notebook ? 13 : 17,
  WebkitLineClamp: 2,
};

const valorSegundo = {
  fontSize: mobile ? 9 : notebook ? 11 : 14,
};

const nomeTerceiro = {
  color: "#fb4b3f",
  fontSize: mobile ? 10 : notebook ? 13 : 17,
  WebkitLineClamp: 2,
};

const valorTerceiro = {
  fontSize: mobile ? 9 : notebook ? 11 : 14,
};

const resumoCard = {
  position: "absolute",
  bottom: "3.4%",
  height: "8.5%",
  borderRadius: notebook ? 12 : 14,
  background: "rgba(15,23,42,0.72)",
  border: "1px solid rgba(255,255,255,0.08)",
  backdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "center",
  gap: notebook ? 8 : 12,
  padding: notebook ? "8px 10px" : "10px 14px",
  boxSizing: "border-box",
  color: "#fff",
  overflow: "hidden",
};

const resumo1 = { left: "4%", width: "30%" };
const resumo2 = { left: "35%", width: "30%" };
const resumo3 = { left: "66%", width: "30%" };

const resumoIcon = {
  fontSize: notebook ? 24 : 30,
  lineHeight: 1,
};

const resumoTitulo = {
  display: "block",
  fontWeight: "900",
  fontSize: notebook ? 13 : 16,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const resumoTexto = {
  display: "block",
  color: "#cbd5e1",
  fontSize: notebook ? 11 : 13,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const linha = {
  display: "flex",
  alignItems: "center",
  gap: mobile ? 10 : 16,
  background: "rgba(15,23,42,0.85)",
  padding: mobile ? 12 : notebook ? 14 : 18,
  borderRadius: mobile ? 18 : 24,
  border: "1px solid rgba(255,255,255,0.08)",
  backdropFilter: "blur(12px)",
  boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
};

const linhaPosicao = {
  fontSize: mobile ? 22 : 28,
  fontWeight: "900",
  width: mobile ? 28 : 36,
  textAlign: "center",
  flexShrink: 0,
};

const linhaNome = {
  fontSize: mobile ? 15 : 17,
  fontWeight: "900",
  marginBottom: 8,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const linhaValor = {
  fontWeight: "900",
  fontSize: mobile ? 14 : 16,
  whiteSpace: "nowrap",
  flexShrink: 0,
};

const barraFundo = {
  width: "100%",
  height: mobile ? 8 : 10,
  borderRadius: 999,
  background: "rgba(255,255,255,0.08)",
  overflow: "hidden",
};

const barraInterna = {
  height: "100%",
  animation: "shineMove 2.5s linear infinite",
  borderRadius: 999,
  background: "linear-gradient(90deg,#06b6d4,#3b82f6,#8b5cf6)",
};

const vazio = {
  background: "rgba(15,23,42,0.92)",
  padding: 24,
  borderRadius: 24,
  textAlign: "center",
  marginTop: 30,
  fontSize: 18,
};
